// pages/InspectorsList.jsx
import React, { useState, useEffect, useMemo } from 'react';
import './InspectorsList.css';

// Excel data converted to JSON format
const inspectorsData = [
  { location: "Mumbai", name: "Om Prakash", mobile: "9728498297", remark: "Mechanical", email: "" },
  { location: "Navi Mumbai", name: "Shakthi Prakesh", mobile: "7021236065", remark: "Mechanical", email: "" },
  { location: "Bamanbor", name: "Sanjay vyas", mobile: "9601506529", remark: "Mechanical", email: "maytriss@gmail.com" },
  { location: "VADODARA", name: "Kunal Sharma", mobile: "88499 84078", remark: "Mechanical", email: "" },
  { location: "Direct", name: "Bala sundaram", mobile: "88499 84078", remark: "Mechanical", email: "bala.t1987@gmail.com" },
  { location: "Navi Mumbai", name: "Somnath Nulke", mobile: "8898201381", remark: "Mechanical", email: "Not avalibile" },
  { location: "Pune", name: "Farooq Goundi", mobile: "9987588060", remark: "Mechanical", email: "" },
  { location: "Pune", name: "Rahuk Parkale", mobile: "9405848422", remark: "Mechanical", email: "" },
  { location: "Andhra", name: "Appalaraju Varada", mobile: "9390223500", remark: "Mechanical", email: "rajumech9390@gmail.com" },
  { location: "Mumbai", name: "Maqsood Alam", mobile: "7888961215", remark: "Mechanical", email: "maqsood.qci@gmail.com" },
  { location: "Telagana", name: "Kranthi Kumar", mobile: "9505650451", remark: "Mechanical", email: "kranthi84tpi@gmail.com" },
  { location: "Gujarat", name: "Mohd Sohail Khan", mobile: "7387812124", remark: "Mechanical", email: "" },
  { location: "Navi Mumbai", name: "MALHARI DOMBALE", mobile: "9987469410", remark: "Mechanical", email: "" },
  { location: "Andhra", name: "Narsimga Prasad", mobile: "9004834056", remark: "Mechanical", email: "" },
  { location: "Palghar", name: "Tushar Ravikant Rao", mobile: "7990347337", remark: "Mechanical", email: "" },
  { location: "Jodhpur", name: "Sushil Gaur", mobile: "9530278378", remark: "Mechanical", email: "gaursushil363@gmail.com" },
  { location: "Bengaluru", name: "Sabari Krish", mobile: "8754915952", remark: "Mechanical", email: "" },
  { location: "YAMUNANAGAR-135001-HARYANA", name: "Balram Rajput", mobile: "90509 17583", remark: "Mechanical", email: "balram084.rajput@gmail.com" },
  { location: "Dankuni ,West Bengal", name: "ALOK KUMAR SAHA", mobile: "9088865641", remark: "Mechanical", email: "amiaksaha20@gmail.com" },
  { location: "Pune", name: "Anshuman Singh", mobile: "8766541701", remark: "Mechanical", email: "" },
  { location: "PATNA", name: "Moin Asraf", mobile: "82875297446", remark: "Mechanical", email: "" },
  { location: "Tarapur", name: "Anand Bhone", mobile: "9890421216", remark: "Mechanical", email: "" },
  { location: "Kouch", name: "Devendra Vikram Singh", mobile: "926572375", remark: "Mechanical", email: "" },
  { location: "Navi Mumbai", name: "S Kumar", mobile: "93455 51616", remark: "Mechanical", email: "" },
  { location: "Banguluru", name: "RM Swami", mobile: "9901745868", remark: "E&I", email: "swamy_rm@yahoo.co.in" },
  { location: "Chennai", name: "Karthikeyan", mobile: "", remark: "E&I", email: "karthikeyan.palanisamy@lrqa.com" },
  { location: "Chennai", name: "S MOHAMED AZAM", mobile: "919245777686", remark: "Mechanical 3.1", email: "mdazam4466@gmail.com" },
  { location: "Pune", name: "Sunil Mali", mobile: "91 96650 54929", remark: "E&I", email: "" },
  { location: "Chennai", name: "MAHENDRAN", mobile: "8667837376", remark: "E&I", email: "" },
  { location: "Gujarat (Sanand)", name: "Vahora Eazaz", mobile: "96016 87261", remark: "Mechanical", email: "azazvahora83@yahoo.com" },
  { location: "Gandhinagar", name: "Vipul Bhatt", mobile: "9909546051", remark: "Mechanical", email: "glis.vipulkbhatt@gmail.com" },
  { location: "Rajasthan", name: "UMARAW SINGH NARSINGHA", mobile: "99833 75551", remark: "Mechanical", email: "" },
  { location: "Udaipur-313001, Rajasthan India", name: "Mr. Arjun", mobile: "86196 62779", remark: "E&I", email: "" },
  { location: "AHMEDABAD", name: "KISHAN DODIYA", mobile: "6359130050", remark: "E&I", email: "" },
  { location: "Hyderabad", name: "Ashwani rai", mobile: "7457013251", remark: "Mechanical", email: "" },
  { location: "Uttar-Pradesh", name: "Mohammad arif", mobile: "9806145761", remark: "Mechanical", email: "" },
  { location: "Delhi", name: "Rajendra singh", mobile: "8265877047", remark: "Mechanical", email: "" },
  { location: "Visakhapatnam", name: "G. Santosh", mobile: "9861040129", remark: "Mechanical", email: "gusuri.santosh@gmail.com" },
  { location: "Navi Mumbai", name: "Hamza Ansari", mobile: "9022248576", remark: "Mechanical", email: "ansarihamza12@gmail.com" },
  { location: "Odisha", name: "Bijay Kumar Mallick", mobile: "9040905375", remark: "Mechanical", email: "bijay_242@rediffmail.com" },
  { location: "KOTPL Kuch", name: "Harish Kumar Gupta", mobile: "7828257892", remark: "Mechanical", email: "harishg090423@gmail.com" },
  { location: "Navi Mumbai", name: "Mr.Vikash", mobile: "9604549829", remark: "Mechanical", email: "" },
  { location: "Ponneri Taluk (Thiruvallur District )", name: "Shiva Ganesh", mobile: "8778283881", remark: "Mechanical", email: "sivaganesh059@gmail.com" },
  { location: "Navi Mumbai", name: "SURAJ GAWADE", mobile: "95943 27789", remark: "Mechanical", email: "smilesuraj804@gmail.com" },
  { location: "VERNA GOA", name: "Sunil Kondalkar", mobile: "91464 39736", remark: "Mechanical", email: "" },
  { location: "Khalapur", name: "Kelusakr", mobile: "96190 28920", remark: "Mechanical", email: "" },
  { location: "", name: "Ravi Dalip", mobile: "8080356941", remark: "Mechanical", email: "" },
  { location: "Gurgaon-122050, Haryana", name: "Paras Rastogi", mobile: "75675 75858", remark: "", email: "" },
  { location: "Kalamboli , Panvel", name: "Pankaj Yadav", mobile: "86938 53454", remark: "Mechanical", email: "" },
  { location: "Village Poman, Off-Bhiwandi Kaman", name: "Tirthraj", mobile: "83906 29563", remark: "Mechanical", email: "" },
  { location: "NAIDUPETA MANDAL Andhra", name: "Satish", mobile: "83744 44944", remark: "Mechanical", email: "" },
  { location: "Chennai", name: "Vinoth Kumar", mobile: "8106672220", remark: "Mechanical", email: "" },
  { location: "Bishnu HALDER", name: "Bishnu Halder", mobile: "8013275657", remark: "Mechanical", email: "" },
  { location: "Vadodara", name: "VINAYKUMAR DALAL", mobile: "9898611291, 9510603846", remark: "E&I", email: "" },
  { location: "Silvassa, Vapi, Daman, umbergaon, Sarigam, sanjan, pardi, Valsad", name: "Deepak", mobile: "9727183798", remark: "Mechanical", email: "" },
  { location: "Waghodia, Vadodara", name: "PRASHANT PATEL", mobile: "76986 31317", remark: "Mechanical", email: "prashant7249@gmail.com" },
  { location: "Ahmedabad - 382 330, Gujarat, INDIA", name: "Niraj Panchal", mobile: "98989 30143", remark: "Mechanical", email: "" },
  { location: "Alleima, Ahmedabad", name: "Mitkumar maval", mobile: "8511257825", remark: "Mechanical", email: "" },
  { location: "Ahmedabad", name: "Ritesh Patel", mobile: "7405908101", remark: "Mechanical", email: "ritesh_patel27@yahoo.co.in" },
  { location: "Mumbai", name: "Prasad", mobile: "9819239268", remark: "cswip and Bgas grade 2", email: "ksprasad2007@gmail.com" },
  { location: "Delhi", name: "Deepak Pal", mobile: "7897319290", remark: "Mechanical", email: "deepakpal459@gmail.com" }
];

const InspectorsList = () => {
    useEffect(() => {
          document.title = "Inspectors-list | Qnexa Services — Engineering & Inspection Specialists";
        }, []);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const itemsPerPage = 20;

  // Calculate statistics
  const statistics = useMemo(() => {
    const total = inspectorsData.length;
    const mechanical = inspectorsData.filter(i => 
      i.remark.toLowerCase().includes('mechanical')
    ).length;
    const ei = inspectorsData.filter(i => 
      i.remark.toLowerCase().includes('e&i')
    ).length;
    const withEmail = inspectorsData.filter(i => 
      i.email && i.email !== '' && !i.email.includes('Not')
    ).length;

    return { total, mechanical, ei, withEmail };
  }, []);

  // Improved search function with fuzzy search and multiple field matching
  const filteredInspectors = useMemo(() => {
    if (!searchTerm.trim()) return inspectorsData;

    const searchTerms = searchTerm.toLowerCase().trim().split(/\s+/);
    
    return inspectorsData.filter(inspector => {
      const searchString = `
        ${inspector.location || ''} 
        ${inspector.name || ''} 
        ${inspector.mobile || ''} 
        ${inspector.remark || ''} 
        ${inspector.email || ''}
      `.toLowerCase();

      // Check if ALL search terms are found in ANY field
      return searchTerms.every(term => searchString.includes(term));
    });
  }, [searchTerm]);

  // Sorting function
  const sortedInspectors = useMemo(() => {
    const sortableItems = [...filteredInspectors];
    
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        let aValue = a[sortConfig.key] || '';
        let bValue = b[sortConfig.key] || '';
        
        // Handle empty values
        if (!aValue && bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue && !bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        if (!aValue && !bValue) return 0;
        
        // Compare values
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    
    return sortableItems;
  }, [filteredInspectors, sortConfig]);

  // Request sort function
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    
    if (email === 'qnexservices@gmail.com' && password === 'Qnexa@123') {
      setIsLoggedIn(true);
      localStorage.setItem('inspectorAuth', 'true');
    } else {
      setError('Invalid email or password');
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('inspectorAuth');
    setEmail('');
    setPassword('');
    setSearchTerm('');
    setSortConfig({ key: null, direction: 'asc' });
  };

  useEffect(() => {
    const auth = localStorage.getItem('inspectorAuth');
    if (auth === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedInspectors.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedInspectors.length / itemsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    // Scroll to top of table when paginating
    document.querySelector('.table-container')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Clear search
  const clearSearch = () => {
    setSearchTerm('');
    setCurrentPage(1);
  };

  if (!isLoggedIn) {
    return (
      <div className="inspectors-login-container">
        <div className="inspectors-login-box">
          <h2>Inspectors Portal Login</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="login-btn">Login</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="inspectors-container">
      <div className="inspectors-header">
        <h1>Inspectors List</h1>
        <div className="header-actions">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search by name, location, mobile, remark, or email..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
            {searchTerm && (
              <button className="clear-search-btn" onClick={clearSearch}>
                ✕
              </button>
            )}
            <span className="search-icon">🔍</span>
          </div>
          <div className="results-info">
            Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, sortedInspectors.length)} of {sortedInspectors.length} inspectors
          </div>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </div>

      <div className="stats-bar">
        <div className="stat-card">
          <div className="stat-number">{statistics.total}</div>
          <div className="stat-label">TOTAL INSPECTORS</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{statistics.mechanical}</div>
          <div className="stat-label">MECHANICAL</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{statistics.ei}</div>
          <div className="stat-label">E&I</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{statistics.withEmail}</div>
          <div className="stat-label">WITH EMAIL</div>
        </div>
      </div>

      <div className="table-container">
        <table className="inspectors-table">
          <thead>
            <tr>
              <th>#</th>
              <th 
                onClick={() => requestSort('location')}
                className="sortable-header"
              >
                LOCATION
                {sortConfig.key === 'location' && (
                  <span className="sort-indicator">
                    {sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th 
                onClick={() => requestSort('name')}
                className="sortable-header"
              >
                INSPECTOR NAME
                {sortConfig.key === 'name' && (
                  <span className="sort-indicator">
                    {sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th 
                onClick={() => requestSort('mobile')}
                className="sortable-header"
              >
                MOBILE NUMBER
                {sortConfig.key === 'mobile' && (
                  <span className="sort-indicator">
                    {sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th 
                onClick={() => requestSort('remark')}
                className="sortable-header"
              >
                REMARK
                {sortConfig.key === 'remark' && (
                  <span className="sort-indicator">
                    {sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
              <th 
                onClick={() => requestSort('email')}
                className="sortable-header"
              >
                EMAIL ID
                {sortConfig.key === 'email' && (
                  <span className="sort-indicator">
                    {sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}
                  </span>
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((inspector, index) => (
                <tr key={index}>
                  <td className="serial-number">{indexOfFirstItem + index + 1}</td>
                  <td>{inspector.location || '-'}</td>
                  <td className="inspector-name">{inspector.name}</td>
                  <td>
                    {inspector.mobile ? (
                      <a href={`tel:${inspector.mobile.replace(/\s/g, '')}`} className="mobile-link">
                        {inspector.mobile}
                      </a>
                    ) : '-'}
                  </td>
                  <td>
                    <span className={`remark-badge ${
                      inspector.remark.toLowerCase().includes('mechanical') ? 'mechanical' : 
                      inspector.remark.toLowerCase().includes('e&i') ? 'ei' : 'other'
                    }`}>
                      {inspector.remark || '-'}
                    </span>
                  </td>
                  <td>
                    {inspector.email && inspector.email !== '' && !inspector.email.includes('Not') ? (
                      <a href={`mailto:${inspector.email}`} className="email-link">
                        {inspector.email}
                      </a>
                    ) : (
                      <span className="no-email">-</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr className="no-results">
                <td colSpan="6">
                  <div className="no-results-content">
                    <span className="no-results-icon">🔍</span>
                    <div>
                      <h3>No inspectors found</h3>
                      <p>Try adjusting your search or filter to find what you're looking for.</p>
                      {searchTerm && (
                        <button onClick={clearSearch} className="clear-search-link">
                          Clear search
                        </button>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container">
          <div className="pagination">
            <button 
              onClick={() => paginate(currentPage - 1)} 
              disabled={currentPage === 1}
              className="page-nav prev"
            >
              ← Previous
            </button>
            
            <div className="page-numbers">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNumber;
                if (totalPages <= 5) {
                  pageNumber = i + 1;
                } else if (currentPage <= 3) {
                  pageNumber = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNumber = totalPages - 4 + i;
                } else {
                  pageNumber = currentPage - 2 + i;
                }

                return (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
                  >
                    {pageNumber}
                  </button>
                );
              })}
              
              {totalPages > 5 && currentPage < totalPages - 2 && (
                <>
                  <span className="ellipsis">...</span>
                  <button
                    onClick={() => paginate(totalPages)}
                    className={`page-number ${currentPage === totalPages ? 'active' : ''}`}
                  >
                    {totalPages}
                  </button>
                </>
              )}
            </div>
            
            <button 
              onClick={() => paginate(currentPage + 1)} 
              disabled={currentPage === totalPages}
              className="page-nav next"
            >
              Next →
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InspectorsList;